export enum MenuItemTypeEnum {
  Food = 1,
  Drink = 2
}
